import { graphql } from "msw";
import { MINUS_ONE } from "CONST/constants";

let idCount = 1;
/* eslint-disable sort-keys */
const tasks = [
    {
        id: `${idCount}`,
        user: "1",
        title: "Summary & Notes",
        body: "You have been assigned to a new document",
        status: "info",
        link: "#",
        actions: [],
        read: true,
        timestamp: 1607904530221,
        tag: "assigned",
    },
    {
        id: `${++idCount}`,
        user: "1",
        title: "Foreword",
        body: "A heading you are assigned to has progressed to a new stage",
        status: "info",
        link: "#",
        actions: [],
        read: true,
        timestamp: 1606904510221,
        tag: "workflowStageChange",
    },
    {
        id: `${++idCount}`,
        user: "1",
        title: "Yearly Summary",
        body:
            "A document you were assigned to has been locked by a workflow rule",
        status: "info",
        link: "#",
        actions: [],
        read: true,
        timestamp: 1607804510000,
        tag: "lock",
    },
    {
        id: `${++idCount}`,
        user: "1",
        title: "Financial Report",
        body:
            "You have been assigned a 'review' action in a document's workflow",
        status: "info",
        link: "#",
        actions: [],
        read: true,
        timestamp: 1607918918126,
        tag: "assigned",
    },
];
/* eslint-enable sort-keys */

export const handlers = [
    graphql.query("Tasks", (req, res, ctx) =>
        res(ctx.delay(), ctx.data(tasks))
    ),
    graphql.query("LoadSingleTask", (req, res, ctx) => {
        const { taskId } = req.variables.payload;
        return res(
            ctx.delay(),
            ctx.data(tasks.find(({ id }) => id === taskId))
        );
    }),
    graphql.mutation("AddTask", (req, res, ctx) => {
        const { task: newTask } = req.variables.payload;
        const id = idCount++;
        const task = {
            id,
            user: "1",
            ...newTask,
        };
        tasks.push(task);
        return res(ctx.delay(), ctx.data({ addTask: task }));
    }),
    graphql.mutation("UpdateManyTasksRead", (req, res, ctx) => {
        const {
            payload: tasksToUpdate,
            context: { user },
        } = req.variables;
        tasksToUpdate.forEach(({ id, read }) => {
            const updateIndex = tasks.findIndex(({ id: nid }) => id === nid);
            if (updateIndex !== MINUS_ONE) {
                tasks[updateIndex].read = read;
            }
        });

        const userTasks = tasks.filter(({ user: uid }) => uid === user);
        return res(ctx.delay(), ctx.data({ updateManyTasksRead: userTasks }));
    }),
];
